import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { BoxSectionComponent } from '@atoms/box-section/box-section.component';
import { IconComponent } from '@atoms/icon/icon.component';
import { ImageComponent } from '@atoms/image/image.component';
import { ParagraphComponent } from '@atoms/paragraph/paragraph.component';
import { TitleComponent } from '@atoms/title/title.component';
import { PricePipe } from '@pipes/price.pipe';
import { CarItem } from '@models/car.model';

@Component({
  selector: 'app-car-detail-price-compare',
  imports: [TranslateModule, BoxSectionComponent, IconComponent, ImageComponent, ParagraphComponent, TitleComponent, PricePipe],
  templateUrl: './car-detail-price-compare.component.html',
  styleUrl: './car-detail-price-compare.component.scss',
})
export class CarDetailPriceCompareComponent {
  @Input() car?: CarItem;
}
